export enum StatusType {
  idle = 'idle',
  success = 'success',
  pending = 'pending',
  error = 'error',
}
